import { sidebarApi } from "../../api";

const SidebarService = {
  /**
   * 🔹 Obtener el perfil activo con sus módulos (agrupados por categoría)
   */
  getActiveProfile: async () => {
    const response = await sidebarApi.fetchAll();
    return response.data;
  },

  /**
   * 🔹 Perfil activo + módulos + menús en un solo payload (árbol completo).
   * Se usa al cargar el sidebar para que el módulo activo se resalte/expanda
   * al recargar la página, sin depender del lazy-load por clic.
   */
  getFullSidebar: async () => {
    const response = await sidebarApi.fetchCustom("/full");
    return response.data;
  },

  /**
   * 🔹 Obtener los menús de un módulo específico
   * @param moduleCode Código técnico del módulo (ej: SALES, INVENTORY)
   */
  getModuleMenus: async (moduleCode: string) => {
    const response = await sidebarApi.fetchCustom(`/modules/${moduleCode}/menus`);
    return response.data;
  },
};

export default SidebarService;
